import React from "react";

export default function nftList() {
  return <div>nftList</div>;
}
